import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';
import { appStrings } from '@backrs_ui/grow-ui/src/assets/appStrings';
import { type EngagementResponse } from '@backrs_ui/grow-ui/src/redux/coachingAnalytics';

const { coachingAnalytics } = appStrings.modules;

/** The recency and activity pair, which also renders outside this section. */
export const useTopCardsAgentContext = (data: EngagementResponse) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.engagement.recency.title,
    display: 'Donut of login recency bands (last 30 / 31–60 / 61–90 / over 90 days).',
    detail: coachingAnalytics.engagement.recency.info,
    data: data.recently_active,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.engagement.activity.title,
    display: 'Trend lines for student posts, goals and comments.',
    detail: [
      coachingAnalytics.engagement.activity.info,
      'The newest month is still in progress, so it runs low until it closes.',
    ].join('\n\n'),
    data: { series: data.activity.monthly.series },
  });
};

export const useAgentContext = (data: EngagementResponse, networkLimit: number) => {
  useRegisterAgentContext({
    kind: 'section',
    title: coachingAnalytics.engagement.title,
    description: coachingAnalytics.engagement.description,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.engagement.networkMembership.title,
    display: 'Network membership bars ranked by member count.',
    detail: coachingAnalytics.engagement.networkMembership.info(networkLimit),
    data: { networks: data.networks },
  });
};

/** The detail-tab cards: profile facts, Success System completion and bookmarks by type. */
export const useDetailAgentContext = (
  data: EngagementResponse,
  bookmarkTypes: EngagementResponse['bookmarks']['types'],
) => {
  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.engagement.profile.title,
    display: 'Horizontal bars: students who have entered each profile fact, out of all students.',
    detail: coachingAnalytics.engagement.profile.info,
    data: data.profile,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.engagement.adoption.title,
    display:
      'Vertical bars: students who completed Blueprint, Are You On Track? and Life Readiness.',
    detail: coachingAnalytics.engagement.adoption.info,
    data: data.completions,
  });

  useRegisterAgentContext({
    kind: 'visual',
    label: coachingAnalytics.engagement.bookmarks.title,
    display:
      'Horizontal bars of total bookmarks per content type, with the students who saved them.',
    detail: coachingAnalytics.engagement.bookmarks.info,
    data: { types: bookmarkTypes },
  });
};
